module.exports = __webpack_public_path__ + "static/media/rss.23ee1404.svg";